export const routes = [
    { path: '/quotes',        label: 'Home' },
    { path: '/authors',     label: 'Authors' },
    { path: '/search',      label: 'Search' },
    { path: '/starred',     label: 'Starred' },
    { path: '/add',       label: 'Quote' },
]



// WEBPACK FOOTER //
// ./src/config.js